import { Component, effect, inject, signal } from '@angular/core';
import { MonKanbanCard } from './atoms/mon-kanban-card/mon-kanban-card';
import { GetMonitoringBriefsDto, GetScreeningBriefsDto, MonitoringBriefResponseDto, MonitoringKanBanStatusEnum, ScreeningKanBanStatusEnum } from '@/app/common/general-types/social-screening.dto';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { form } from '@angular/forms/signals';
import { Subscription, Subject, debounceTime } from 'rxjs';
import { SocialMonitoring } from '@/app/services/social-monitoring/social-monitoring';

@Component({
  selector: 'mon-monitoring-briefs',
  imports: [MonKanbanCard],
  templateUrl: './monitoring-briefs.html',
  styleUrl: './monitoring-briefs.css',
})
export class MonitoringBriefs {

  /** Services */
  private currentUserService = inject(CurrentUserService);
  public socialMonitoringService = inject(SocialMonitoring);
  /** Services - END */

  private isInitialized = false;

  private subscriptions = new Subscription();
  private searchQuerySubject = new Subject<string>();
  searchQueryModel = signal({
    query: '',
  })
  searchQueryForm = form(this.searchQueryModel)

  notReadyFilter = signal<GetMonitoringBriefsDto>({
    businessAccountId: this.currentUserService.focussedBrand.id,
    take: 10,
    skip: 0,
    status: MonitoringKanBanStatusEnum.Not_Ready,
  });
  notReadyBriefs = signal<MonitoringBriefResponseDto[]>([]);


  processingFilter = signal<GetMonitoringBriefsDto>({
    businessAccountId: this.currentUserService.focussedBrand.id,
    take: 10,
    skip: 0,
    status: MonitoringKanBanStatusEnum.Processing,
  });
  processingBriefs = signal<MonitoringBriefResponseDto[]>([]);

  refinementFilter = signal<GetMonitoringBriefsDto>({
    businessAccountId: this.currentUserService.focussedBrand.id,
    take: 10,
    skip: 0,
    status: MonitoringKanBanStatusEnum.Refinement,
  });
  refinementBriefs = signal<MonitoringBriefResponseDto[]>([]);


  monitoringFilter = signal<GetMonitoringBriefsDto>({
    businessAccountId: this.currentUserService.focussedBrand.id,
    take: 10,
    skip: 0,
    status: MonitoringKanBanStatusEnum.Monitoring,
  });
  monitoringBriefs = signal<MonitoringBriefResponseDto[]>([]);

  completeFilter = signal<GetMonitoringBriefsDto>({
    businessAccountId: this.currentUserService.focussedBrand.id,
    take: 10,
    skip: 0,
    status: MonitoringKanBanStatusEnum.Complete,
  });
  completeBriefs = signal<MonitoringBriefResponseDto[]>([]);

  
  constructor() {
    this.subscriptions.add(
      this.searchQuerySubject.pipe(debounceTime(350)).subscribe(query => {
        console.log('query changed:', query);
        if (this.isInitialized) {

        }
      })
    );

    effect(() => {
      const query = this.searchQueryModel().query;
      this.searchQuerySubject.next(query);
    });
  }

  ngOnInit(): void {
    this.getMonitoringBriefs();
  }

  getMonitoringBriefs() {
    this.getNotReadyBriefs();
    this.getProcessingBriefs();
    this.getRefinementBriefs();
    this.getInProgressBriefs();
    this.getCompleteBriefs();
  }

  getNotReadyBriefs() {
    this.socialMonitoringService.getSocialMonitoringBriefs(this.notReadyFilter()).subscribe((notReadyRes: MonitoringBriefResponseDto[]) => {
      this.notReadyBriefs.set(notReadyRes);
      console.log('Not Ready Briefs:', notReadyRes);
      this.notReadyFilter.update(filter => ({ ...filter, skip: filter.skip + filter.take }));
    });
  }

  getProcessingBriefs() {
    this.socialMonitoringService.getSocialMonitoringBriefs(this.processingFilter()).subscribe((processingRes: MonitoringBriefResponseDto[]) => {
      this.processingBriefs.set(processingRes);
      console.log('Processing Briefs:', processingRes);
      this.processingFilter.update(filter => ({ ...filter, skip: filter.skip + filter.take }));
    });
  }
  
  getRefinementBriefs() {
    this.socialMonitoringService.getSocialMonitoringBriefs(this.refinementFilter()).subscribe((refinementRes: MonitoringBriefResponseDto[]) => {
      this.refinementBriefs.set(refinementRes);
      console.log('Refinement Briefs:', refinementRes);
      this.refinementFilter.update(filter => ({ ...filter, skip: filter.skip + filter.take }));
    });
  }

  getInProgressBriefs() {
    this.socialMonitoringService.getSocialMonitoringBriefs(this.monitoringFilter()).subscribe((monitoringRes: MonitoringBriefResponseDto[]) => {
      this.monitoringBriefs.set(monitoringRes);
      console.log('Monitoring Briefs:', monitoringRes);
      this.monitoringFilter.update(filter => ({ ...filter, skip: filter.skip + filter.take }));
    });
  }

  getCompleteBriefs() {
    this.socialMonitoringService.getSocialMonitoringBriefs(this.completeFilter()).subscribe((completeRes: MonitoringBriefResponseDto[]) => {
      this.completeBriefs.set(completeRes);
      console.log('Complete Briefs:', completeRes);
      this.completeFilter.update(filter => ({ ...filter, skip: filter.skip + filter.take }));
    });
  }

}
